import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { TradeShows as TradeShowsComponent } from '../../../tradeShows/TradeShows';

export const TradeShowListing = () => {
  const data = useStaticQuery(graphql`
    query {
      allUmbracoTradeShowType(sort: { startDate: DESC }) {
        nodes {
          description
          endDate
          name
          location
          startDate
          logo {
            image {
              ...TradeShowImage
            }
          }
          tradeShowLink
        }
        totalCount
      }
    }
  `);

  return (
    <TradeShowsComponent tradeShows={data?.allUmbracoTradeShowType?.nodes} />
  );
};
